module.exports = __webpack_public_path__ + "img/calculator-solid.ff29dff.svg";